import React from 'react';
import { useTranslation } from 'react-i18next';
import './LoadingScreen.css';

const LoadingScreen = () => {
    const { t } = useTranslation('games');
    
    return (
        <div className="loading-screen-overlay">
            <div className="loading-screen-content">
                <p>{t('loading.loadingAssets')}</p>
                <div className="loading-spinner"></div>
            </div>
        </div>
    );
};

export default LoadingScreen;